import axios from 'axios';

export default class Api {
    ww = "vbijdsg447gfvasfuh(dsfg*)__bver7asgr_sdgdsfgsdarhnpiujhner";

    /**
     *
     * @param {Object} options axios constructor options.
     */
    constructor(options) {
        this.instance = axios.create({
            ...{
                responseType: 'json'
            }, ...options
        });

        this.instance.interceptors.response.use(null, function(err) {
            window.Sentry.setExtra('error', err);
            window.Sentry.setExtra('response', err.response);
            window.Sentry.captureException(err);
            throw err;
        });
    }

    /**
     * Upload data to the server.
     * @param {Blob} recordedChunks Recording from the recorder object.
     * @param {String} name Name of the file.
     * @param {boolean} isTestRecording should file be sent as test recording or real recording
     * @return {Promise}
     */
    uploadVideo(recordedChunks, name, isTestRecording) {
        // Keep the real recording type (mp4 on iOS, webm elsewhere).
        let blob = new Blob([recordedChunks], {type: (recordedChunks && recordedChunks.type) || 'video/webm'});

        let megabytes = (blob.size / 1024 / 1024).toFixed(2);
        const data = new FormData();
        data.append('file', blob, name);
        window.Vue.log('Upload starting [ ' + megabytes + 'MB ]');
        let command = isTestRecording ? "STORECAMTEST" : "STOREREACTION";
        let timeout = isTestRecording ? 10000 : 0;

        window.Vue.$state.uploads.in_progress++;
        let timeStart = new Date().getTime();
        return this.instance.post('?code=' + window.Vue.$state.logged_in + '&ww=' + this.ww + '&cmd=' + command, data, {
            timeout: timeout, headers: {
                'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
            }
        }).then(() => {
            let timeEnd = new Date().getTime();
            window.Vue.log('Upload completed [ ' + megabytes + 'MB ] [' + (timeEnd - timeStart) + 'ms]');
            window.Vue.$state.uploads.completed++;
            window.Vue.$state.uploads.in_progress--;
        }).catch((error) => {
            let timeEnd = new Date().getTime();
            window.Vue.log(error, true);
            // Save arguments to $state so we can call it again later.
            window.Vue.$state.uploads.failed.push([
                recordedChunks,
                name,
                isTestRecording
            ]);
            window.Vue.$state.uploads.in_progress--;
            throw error;
        });
    }

    login(code) {
        return this.instance.get('https://beheer.vipscan.nl/Webversie2019.php?code=' + code + '&ww=vbijdsg447gfvasfuh(dsfg*)__bver7asgr_sdgdsfgsdarhnpiujhner&cmd=LIN')
            .then((response) => {
                window.Vue.$root.$emit('login', response);
                return response;
            })
    };

    logError(msg, isError) {
        let cmd = 'LOGGER';
        if(isError) cmd = 'ERROR';

        if(window.Vue.$state.logged_in)
            msg = window.Vue.$state.logged_in + ": " + msg;

        return this.instance.get('?code=' + window.Vue.$state.logged_in + '&ww=' + this.ww + '&cmd=' + cmd + '&msg=' + msg);
    };

    testDone() {
        window.Vue.log("Test Done.");
        return this.instance.get('?code=' + window.Vue.$state.logged_in + '&ww=' + this.ww + '&cmd=ZZZ');
    };
}
